/// <amd-module name="TFS/Admin/Common/Util/EmailValidator" />
export function validateEmail(email: string): boolean {
    email = email.trim();

    if (!!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g.test(email)) return true;

    return false;
}
